import type React from 'react'
import styled from 'styled-components'

import Tooltip from './IconGroup/TooltipIcon'

interface Props {
  visitors: string[]
}

const Container = styled.div`
  padding: 15px 0px 0px 0px;
  width: fit-content;
`

const VisitorPanel: React.FC<Props> = ({ visitors = [] }) => {
  const visitorsToTooltip = () => {
    return 'Viewed by: ' + visitors.join(', ')
  }

  if (visitors.length === 0) {
    return <Container></Container>
  }

  if (visitors.length === 1) {
    return (
      <Container>
        <Tooltip
          icon={<p>{visitors.length} person is viewing this application</p>}
          tooltipMessage={visitorsToTooltip()}
        />
      </Container>
    )
  }

  return (
    <Container>
      <Tooltip
        icon={<p>{visitors.length} People are viewing this application</p>}
        tooltipMessage={visitorsToTooltip()}
      />
    </Container>
  )
}

export default VisitorPanel
